import React, { useState, useEffect } from 'react';
import {
  PodSection,
  ProductImage,
  ProductPod,
  ProductRating
} from '@thd-olt-component-react/product-pod';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { extend, useDataModel } from '@thd-nucleus/data-sources';
import { useCompatibleAccessories } from './CompatibleAccessoriesProvider';
import { CompatibleAccessoriesLoader } from './CompatibleAccessoriesLoader';
import { TARGET_MAPPING } from '../constants';

export const CompatibleAccessoriesPod = () => {
  const {
    accessoryItemId,
    parent,
    storeId,
    zipCode,
    hasCheckbox,
    channel
  } = useCompatibleAccessories();

  const target = TARGET_MAPPING[parent];

  const [host, setHost] = useState(null);

  useEffect(() => {
    if (window.location?.origin) {
      setHost(window.location.origin);
    }
  }, []);

  const { data, loading } = useDataModel('product', {
    variables: {
      itemId: accessoryItemId,
      storeId
    }
  });

  if (!data || loading) {
    return (
      <div>
        <CompatibleAccessoriesLoader hideRequiredText />
      </div>
    );
  }

  return (
    <ProductPod
      itemId={accessoryItemId}
      analyticsData={{ parent: 'compatible-accesories' }}
      padding="0"
      storeId={storeId}
      render={({ itemId }) => (
        <div className="sui-flex sui-gap-2">
          <PodSection noPadding>
            <div className="sui-w-28">
              <ProductImage itemId={itemId} target={target} />
            </div>
          </PodSection>
          <div className="sui-flex sui-flex-col sui-gap-2">
            <PodSection noPadding>
              <ProductHeader itemId={itemId} target={target} brand="inline" />
            </PodSection>
            <PodSection noPadding>
              <ProductRating itemId={itemId} target={target} />
            </PodSection>
            <PodSection noPadding>
              <Price
                type="simple"
                itemId={itemId}
                target={target}
                storeId={storeId}
                displayEachUom={false}
                hideSavingsText
                clsRemediation={{
                  placeholders: true,
                  preservePlaceholders: true
                }}
              />
            </PodSection>
            {!hasCheckbox && (
              <PodSection noPadding>
                <div className="sui-min-w-36">
                  <AddToCart
                    itemId={itemId}
                    storeId={storeId}
                    variant="secondary"
                    fullWidth
                    cartReqParams={{
                      applianceDeliveryStore: storeId,
                      assembleItemAtStore: 'N',
                      itemId,
                      quantity: 1,
                      fulfillmentMethod: 'ShipToHome',
                      fulfillmentLocation: zipCode
                    }}
                    cartOptions={{
                      host,
                      channel,
                      misship: false,
                      directCheckout: false,
                      hasConfigurableItems: false,
                      bss: false,
                      component: 'compatible accessories',
                      alterBrowserHistory: true,
                      bypassBss: false,
                      sharedSection: 'water filter test'
                    }}
                  >
                    Add To Cart
                  </AddToCart>
                </div>
              </PodSection>
            )}
          </div>
        </div>
      )}
    />
  );
};

CompatibleAccessoriesPod.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductHeader,
  ProductRating
);
